export default __webpack_public_path__ + "static/media/pngLogo.e7f56225.svg";